import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const r = await exchangeSession(sessionId);
        setUser(r.data);
        // strip hash & go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-zinc-950"
      data-testid="auth-callback-screen"
    >
      <div className="font-mono text-brass-400 text-sm tracking-widest uppercase architecting-dot">
        {error || "Authenticating..."}
      </div>
    </div>
  );
}
